import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  let winners = [
    "349", "428", "486", "312", "373", "323", "314", "319"
  ];
  return <IndividualTable matchType={"16"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="8" winners={winners} />;
};
export default Distance70;
